/* eslint-disable eqeqeq */
import _ from "lodash";

export interface IEmployeeDetail {
  Title: string;
  eMail: String;
}

export function getEmployeeDetail(
  email: string,
  employees: any[],
  software: any
): IEmployeeDetail[] {
  let employee1: any[] = [];
  try {
    employee1 = employees?.filter((employee) => employee.eMail === email);
  } catch (error) {}
  let employee2: any[] = [];
  try {
    employee2 = software
      ?.filter((employee: any) => employee?.eITStaff?.split("|")[0] === email)
      ?.map((employee: any) => {
        return {
          ...employee,
          Title: employee.eITStaff.split("|")[1],
          eMail: employee.eITStaff.split("|")[0],
        };
      });
  } catch (error) {}

  return [...employee1, ...employee2];
}

export function getApproverName(
  email: string,
  employees: any[],
  software: any[],
  approver: string
) {
  const approverEmail = approver?.split("|")?.[0];
  const approverName = approver?.split("|")?.[1] || "";

  if (
    email &&
    approverEmail &&
    email.toLowerCase() === approverEmail.toLowerCase()
  ) {
    return approverName;
  } else {
    return (
      getEmployeeDetail(email, employees, software)?.[0]?.Title || approverName
    );
  }
}

export function getApprover(
  email: string,
  employees: any[],
  software: any[],
  approver: string
) {
  const approverEmail = approver?.split("|")?.[0];

  if (
    email &&
    approverEmail &&
    email.toLowerCase() === approverEmail.toLowerCase()
  ) {
    return approver;
  } else {
    return `${email}|${
      getEmployeeDetail(email, employees, software)?.[0]?.Title || ""
    }`;
  }
}

export function filterEmployee(
  employees: any[],
  branch: string,
  code?: string
) {
  let newEmployees: any[] = _.cloneDeep(employees);

  if (branch && branch.toUpperCase() == "TSN") {
    newEmployees = newEmployees.filter((value) =>
      ["TSN", "VTSN"].includes(value.eLocation)
    );
  } else if (branch && branch.toUpperCase() == "NBA") {
    newEmployees = newEmployees.filter((value) =>
      ["NBA", "VNBA"].includes(value.eLocation)
    );
  } else if (branch && branch.toUpperCase() == "DAD") {
    newEmployees = newEmployees.filter((value) =>
      ["DAD", "VDAD"].includes(value.eLocation)
    );
  }

  if (code && code == "TP") {
    newEmployees = newEmployees.filter((value) =>
      ["TP", "PP"].includes(value.eBizTitleCode)
    );
  } else if (code && code == "GD") {
    newEmployees = newEmployees.filter((value) =>
      ["GD"].includes(value.eBizTitleCode)
    );
  }

  return newEmployees;
}

export function getEmployeeBizTitleByBranch(branch: string, code: string) {
  if (code == "TP") {
    if (branch === "TSN") {
      return "Trưởng phòng TCNL";
    }
    if (branch === "NBA") {
      return "Trưởng phòng KHHC - Nội Bài";
    }
    if (branch === "DAD") {
      return "Trưởng phòng KHHC - Đà Nẵng";
    }
  }
}
